import { render } from "./AdminList.vue?vue&type=template&id=f276d678&scoped=true"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"

import "./AdminList.vue?vue&type=style&index=0&id=f276d678&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Experts\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f276d678"]])

export default __exports__